import { z } from 'zod/v3';
import { zCode, zIsoDate } from '../../../../common/utils';

const AlgorithmCloneBaseValidFormDataSchema = z.object({
  id: z.number(),
  code: zCode(),
});

export const AlgorithmCloneValidFormDataSchema = z.discriminatedUnion(
  'isFinish',
  [
    AlgorithmCloneBaseValidFormDataSchema.extend({
      isFinish: z.literal(true),
      validTo: zIsoDate(),
    }),
    AlgorithmCloneBaseValidFormDataSchema.extend({
      isFinish: z.literal(false),
      validTo: z.null().optional(),
    }),
  ],
);
